/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

import React, {useState} from "react";
import {WealthyEnv, getAuthToken} from "helpers";
import styled, {css} from "styled-components";

import MobileNavbar from "./components/MobileNavbar";
import PropTypes from "prop-types";
import navLinks from "./constants";

const wealthyColoredLogo = `${WealthyEnv.HOMEPAGE_CDN_URL}/wl_colorful_logo.png`;

const propTypes = {
  allowSticky: PropTypes.bool.isRequired,
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  isNewPartnerPage: PropTypes.bool,
  logo: wealthyColoredLogo,
  setToggleModal: PropTypes.func
};

const defaultProps = {
  backgroundColor: "transparent",
  allowSticky: false,
  color: "#000",
  logo: wealthyColoredLogo,
  isNewPartnerPage: false,
  setToggleModal: PropTypes.func
};

const NewHeader = ({
  allowSticky,
  backgroundColor,
  logo,
  color,
  isNewPartnerPage,
  setToggleModal
}) => {
  const [activeLink, setActiveLink] = useState({});
  const [sticky, setIsSticky] = useState(false);
  const [showSidePanel, toggleShowSidePanel] = useState(false);

  const isAuthTokenAvailable = getAuthToken();

  let directClientUrl = `${WealthyEnv.GATE_WEALTHY_API_URL}/wealthyauth/dashboard/login/?redirect_url=${WealthyEnv.APP_URL}`;
  let directTradeUrl = `${WealthyEnv.GATE_WEALTHY_API_URL}/wealthyauth/dashboard/login/?redirect_url=${WealthyEnv.TESSERACT_BASE_URL}`;

  if (isAuthTokenAvailable?.length > 0) {
    directClientUrl = WealthyEnv.APP_URL;
    directTradeUrl = WealthyEnv.TESSERACT_BASE_URL;
  }

  const isMobileView = React.useRef(false);

  React.useEffect(() => {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    isMobileView.current = isMobile;
  }, []);

  React.useEffect(() => {
    if (showSidePanel) {
      document.body.classList.add("hide-scroll");
    } else {
      document.body.classList.remove("hide-scroll");
    }
  }, [showSidePanel]);

  React.useEffect(() => {
    const pathname = window.location.pathname;

    const activeNavLink = navLinks.find(navLink => {
      if (navLink.pathname === pathname) {
        return true;
      } else {
        navLink?.subLinks?.map(subLink => {
          if (subLink.pathname === pathname) {
            return true;
          }
        });
      }
    });

    setActiveLink(activeNavLink || {});
  }, []);

  React.useEffect(() => {
    window.addEventListener("scroll", () => {
      const windowScroll = window.scrollY;
      const screenHeight = window.innerHeight;
      const wealthyLogoImage = document.querySelector(".wealthy-logo-img");
      if (windowScroll > screenHeight && allowSticky) {
        wealthyLogoImage.src = wealthyColoredLogo;
        setIsSticky(true);
      } else {
        wealthyLogoImage.src = logo;
        setIsSticky(false);
      }
    });
  }, []);

  const isActiveLinkPresent = activeLink.url;
  const homeUrl = WealthyEnv.URL;

  return (
    <Container
      $backgroundColor={backgroundColor}
      $color={color}
      $isNewPartnerPage={isNewPartnerPage}
      $sticky={sticky}
    >
      <Nav>
        <LogoContainer href={homeUrl} isNewPartnerPage={isNewPartnerPage}>
          <Logo
            alt="wealthy-logo-image"
            className="wealthy-logo-img"
            Loading="lazy"
            src={logo}
          />
        </LogoContainer>
        <DesktopNavbar>
          <NavbarLinksContainer
            isActiveLinkPresent={isActiveLinkPresent}
            isNewInvestorsPage={isActiveLinkPresent && activeLink.isNewInvestorsPage}
          >
            {
              isActiveLinkPresent ?
                (
                  <>
                    {
                      activeLink?.subLinks?.map(subLink => {
                        if (subLink.dropdownLinks) {
                          return (
                            <NavLink>
                              <DropdownNavLink style={subLink.style}>
                                {subLink.text} <Caret>&nbsp;</Caret>
                              </DropdownNavLink>
                              <DropdownLinks
                                className="dropdown-links"
                                isInvestorsPage={!!activeLink.isNewInvestorsPage}
                              >
                                {subLink.dropdownLinks.map((dropdownLink, index) => {
                                  return (
                                    <DropdownLink
                                      href={dropdownLink.url}
                                      key={index}
                                      style={dropdownLink.style}
                                    >
                                      {dropdownLink.text}
                                    </DropdownLink>
                                  );
                                })}
                              </DropdownLinks>
                            </NavLink>
                          );
                        } else {
                          return (
                            <NavLink>
                              <Link href={subLink.url} style={subLink.style}>
                                {subLink.text}
                              </Link>
                            </NavLink>
                          );
                        }
                      })
                    }
                  </>
                ) :
                (
                  <>
                    <NavLink>
                      <Link href={`${WealthyEnv.URL}`}>
                        FOR CLIENTS
                      </Link>
                    </NavLink>
                    <NavLink>
                      <Link href={`${WealthyEnv.URL}/partner`}>
                        FOR PARTNERS
                      </Link>
                    </NavLink>
                    <NavLink>
                      <Link href={`${WealthyEnv.URL}/careers`}>
                        CAREERS
                      </Link>
                    </NavLink>
                  </>
                )
            }
          </NavbarLinksContainer>

          <LoginButtonContainers>

            {/* {
              activeLink.loginUrlFromPartners && activeLink.loginUrlFromPartners.length > 0 && (
                <LoginJoinNowContainer>
                  <LoginPartners
                    href={!isNewPartnerPage ? directTradeUrl : activeLink.loginUrlFromPartners}
                    isInvestorsPage={!!activeLink.isNewInvestorsPage}
                  >
                  Trade Now
                  </LoginPartners>
                  {
                    !activeLink.isNewInvestorsPage && (
                      <JoinNowButton href="#register">
                      Join as Partner
                      </JoinNowButton>
                    )
                  }
                </LoginJoinNowContainer>
              )
            } */}

            {/* This section is Specifically for new partners page and investors page*/}
            {
              activeLink.loginUrlFromPartners && activeLink.loginUrlFromPartners.length > 0 && (
                <LoginJoinNowContainer>
                  <LoginPartners
                    href={!isNewPartnerPage ? directTradeUrl : undefined}
                    isInvestorsPage={!!activeLink.isNewInvestorsPage}
                    onClick={isNewPartnerPage ? () => setToggleModal(true) : undefined}
                  >
                  Log In
                  </LoginPartners>
                  {
                    !activeLink.isNewInvestorsPage && (
                      <JoinNowButton href="#register">
                      Join as Partner
                      </JoinNowButton>
                    )
                  }
                </LoginJoinNowContainer>
              )
            }

          </LoginButtonContainers>

          <AppLinks className="app-links">
            {
              isActiveLinkPresent &&
              (
                <>
                  {
                    activeLink.loginUrl &&
                    (
                      <Login href={activeLink.loginUrl}>
                        LOGIN
                      </Login>
                    )
                  }
                  {
                    activeLink.downloadUrl &&
                    (
                      <Download
                        className="download-app-btn"
                        href={activeLink.downloadUrl}
                      >
                        DOWNLOAD APP
                      </Download>
                    )
                  }
                </>
              )
            }
            {
              activeLink.adjacentLink &&
              (
                <AdjacentLinkContainer className="adjacent-link-container">
                  <AdjacentLink
                    className="adjacent-link"
                    href={activeLink.adjacentLink.url}
                  >
                    {activeLink.adjacentLink.text}
                  </AdjacentLink>
                </AdjacentLinkContainer>
              )
            }
          </AppLinks>
        </DesktopNavbar>
        {/* Mobile Navbar */}

        <MobileNavbar
          activeLink={activeLink}
          color={color}
          isNewPartnerPage={isNewPartnerPage}
          setToggleModal={setToggleModal}
          showSidePanel={showSidePanel}
          toggleShowSidePanel={toggleShowSidePanel}
        />

      </Nav>
    </Container>
  );
};

const LoginButtonContainers = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 2rem;
`;

const Container = styled.header`
  --link-color: ${props => props.color};
  --link-font-size: 1.5rem;
  height: ${props => props.$isNewPartnerPage ? "100px" : "60px"};
  width: 100vw;
  z-index: 5;
  background: transparent;
  color: var(--link-color);
  font-family: Avenir-Book;
  display: flex;
  align-items: center;
  transition: all 200ms ease;
  z-index: 888;
  position: relative;
  background: ${props => props.$backgroundColor};

  @media (max-width: 1024px) {
    --link-font-size: 1.4rem;
  }

  a {
    text-decoration: none;
  }

  .app-links {
    margin-right: 2.75%;
  }

  ${props => props.$sticky && css`
    --link-color: #000;
    @media (min-width: 769px) {
      position: fixed!important;
      background: #fff!important;
      box-shadow: 0 0 10.4px 1.6px rgb(25 80 155 / 17%);
      opacity: 1!important;
      top: 0;

      .app-links {
        margin-right: 0;
      }

      .dropdown-links {
        border: 5px solid #eceff1;

        &::before {
          border-top-color: #eceff1;
          border-left-color: #eceff1;
        }
      }

      .adjacent-link-container {
        margin-top: 0;
        height: 100%;
        background: var(--link-color);

        .adjacent-link {
          color: #fff;
          padding-right: 2rem;

          &::after {
            content: "\\2192"\;
            margin-left: 5px;
            font-size: 20px;
            color: #fff;
          }
        }
      }

      .download-app-btn:hover {
        background: var(--link-color);
        border-color: var(--link-color);
        color: #fff;
      }
    `}
  }
`;


const LoginJoinNowContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const LoginPartners = styled.a`
  font-family: Avenir-Book;
  font-size: 1.8rem;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #1C1C1C;
  cursor: pointer;
  position: relative;

  ${props => props.isInvestorsPage && css`
    :after {
      position: absolute;
      content: '';
      border-bottom: 1px solid #1C1C1C;
      width: 100%;
      transform: translateX(-50%);
      bottom: -1.2rem;
      left: 50%;
    }
  `}
`;

const JoinNowButton = styled.a`
  font-family: Avenir-Book;
  margin-left: 5rem;
  font-size: 1.8rem;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #6725F4;
  padding: 0 !important;
  position: relative;

  :after {
    position: absolute;
    content: '';
    border-bottom: 1px solid #6725F4;
    width: 100%;
    transform: translateX(-50%);
    bottom: -1.2rem;
    left: 50%;
  }
`;

const Nav = styled.nav`
  display: flex;
  width: 98%;
  margin-left: auto;
  height: 100%;
`;

const LogoContainer = styled.a`
  align-self: center;
  width: 120px;
  ${props => props.isNewPartnerPage && css`
    width: 18rem;
    height: 5.2rem;
  `}
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 1;
`;

const Logo = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  margin-left: 1rem;
`;

const DesktopNavbar = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 1;

  @media (max-width: 768px) {
    display: none;
  }
`;

const NavbarLinksContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center !important;
  margin-left: -120px;

  ${props => props.isActiveLinkPresent && css`
    justify-content: unset;
    min-width: 400px;
    margin-left: 5rem;
  `}

  ${props => props.isNewInvestorsPage && css`
    margin-left: 0;
  `}

  align-items: center;

  @media (max-width: 768px) {
    display: none;
  }
`;

const NavLink = styled.div`
  position: relative;

  &:not(:first-child) {
    margin-left: 5rem;
  }

  &:hover .dropdown-links {
    display: flex;
  }
`;

const Link = styled.a`
  font-size: var(--link-font-size);
  font-family: Avenir-Heavy;
  cursor: pointer;
  color: var(--link-color);
  /* color: #fff; */
`;

const AppLinks = styled.div`
  display: flex;
  margin-left: auto;

  @media (max-width: 768px) {
    display: none;
  }
`;

const Login = styled.a`
  font-size: var(--link-font-size);
  font-family: Avenir-Heavy;
  align-self: center;
  cursor: pointer;
  color: var(--link-color);
`;

const Download = styled.a`
  border-radius: 50px;
  font-size: var(--link-font-size);
  font-family: Avenir-Heavy;
  border: 1px solid var(--link-color);
  padding: 0.6rem 1.2rem;
  margin-left: 2rem;
  align-self: center;
  cursor: pointer;
  transition: all 200ms ease;
  color: var(--link-color);
`;

const AdjacentLinkContainer = styled.div`
  display: flex;
  align-items: center;
  height: 60%;
  align-self: center;
  margin-left: 2rem;
`;

const AdjacentLink = styled.a`
  font-family: Avenir-Book;
  font-size: 1.8rem;
  font-weight: 600;
  cursor: pointer;
  padding-left: 2rem;
  display: flex;
  align-items: center;
  height: 100%;
  color: var(--link-color);
`;

const DropdownNavLink = styled.div`
  font-size: var(--link-font-size);
  font-family: Avenir-Heavy;
  cursor: pointer;
  color: var(--link-color);

  &:hover + .dropdown-links {
    display: flex;
  }
`;

const Caret = styled.span`
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 4px;
  vertical-align: middle;
  color: var(--link-color);
  border-top: 4px dashed;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
  transition: all 0.25s;
  cursor: pointer;
`;

const DropdownLinks = styled.div`
  position: absolute;
  left: 0;
  top: 50px;
  border: 5px solid transparent;
  border-radius: 5px;
  background: #fff;
  display: none;
  transition: all 200ms ease;
  z-index: 99999;
  flex-direction: column;
  width: max-content;

  &::before {
    content: "";
    position: absolute;
    left: calc(50% - 10px);
    margin-top: -7px;
    width: 0;
    height: 0;
    border: 7px solid transparent;
    z-index: -1;
    transform: rotate(45deg);
  }

  &::after {
    content: "";
    position: absolute;
    top: -50px;
    background: 0 0;
    height: 100%;
    width: 100%;
    cursor: pointer;
    z-index: -2;
  }

  ${props => props.isInvestorsPage && css`
    &::after {
      top: -30px;
    }
  `}


`;

const DropdownLink = styled.a`
  padding: 8px 15px;
  color: #193076;
  text-align: center;
  font-size: 15px;
  text-transform: capitalize;
  background: 0 0;

  &:hover {
    background: #eceff1;
    border-radius: 3px;
  }
`;

NewHeader.propTypes = propTypes;
NewHeader.defaultProps = defaultProps;

export default NewHeader;
